
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(193, 68, 14, 0.85), rgba(47, 47, 47, 0.75)), url('https://public.readdy.ai/ai/img_res/409d9048851fca65c39d5bac9083f0f4.jpg')`
      }}
    >
      <div className="container mx-auto px-4 py-20 mt-20">
        <div className="w-full max-w-4xl mx-auto text-center text-white font-nunito">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Dépannage électrique urgent
            <br />
            <span className="text-amber-300">intervention en ~30 min*</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-stone-100">
            Pannes, courts-circuits, coupure totale ou partielle
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <a
              href="tel:+33656847324"
              className="inline-flex items-center bg-red-600 text-white px-10 py-5 rounded-full font-bold hover:bg-red-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer font-nunito"
            >
              <i className="ri-phone-line mr-3 text-3xl"></i>
              <span className="text-2xl">06 56 84 73 24</span>
            </a>
            <button
              onClick={scrollToContact}
              className="inline-flex items-center bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-text-line mr-3 text-xl"></i>
              Nous contacter
            </button>
          </div>
          
          <p className="text-sm text-stone-200">
            * selon disponibilité et distance
          </p>
        </div>
      </div>
    </section>
  );
}
